import request from '@/utils/request'

let Student_infoApi = {

  /*学生信息列表*/
  list(data) {
    return request._post('/shop/plus.student_info.Index/index', data);
},
/*添加学生信息*/
add(data) {
    return request._post('/shop/plus.student_info.Index/add', data);
},
/*修改学生信息*/
edit(data) {
    return request._post('/shop/plus.student_info.Index/edit', data);
},
/*删除学生信息*/
del(data) {
    return request._post('/shop/plus.student_info.Index/del', data);
},
/*学生信息详情*/
detail(data) {
  return request._post('/shop/plus.student_info.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.student_info.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.student_info.Setting/getSetting', data, errorback);
    },
}
export default Student_infoApi;



// WEBPACK FOOTER //
// ./src/api/student_info.js